import {mapGetters, mapActions} from 'vuex'
export const InitializingCountriesMixin = {
  computed: {
    ...mapGetters(['countries']),
  },
  methods: {
    ...mapActions(['set_countries']),
  },
  created() {
    if (! this.countries.length) {
        this.loading = true
        this.set_countries().then(() => {this.loading = false}).catch(() => {this.loading = false})
    }
  },
}
